var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2DiningRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 20.23V41h-3v16.69a1.9 1.9 0 01-1.93 1.85A2 2 0 0156 57.69V20.34a3.72 3.72 0 012.37-3.54A3.49 3.49 0 0163 20.23zM47 31h-4V17h-4v14h-4V17h-4v14a10 10 0 008 9.8V58a2 2 0 004 0V40.8a10 10 0 008-9.8V17h-4v14zM13 17.21v4.36a18.07 18.07 0 010 32.7v4.36a22.11 22.11 0 000-41.42z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Dining_room_bis.30cfc748.svg";
export { SvgE2DiningRoomBis as ReactComponent };